import { usePage } from "@inertiajs/react"
import { type ReactNode, useEffect } from "react"

import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { initializePostHog } from "@/lib/posthog"
import type { SharedProps } from "@/types"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  const { auth, posthog } = usePage<SharedProps>().props

  useFlash()
  useEffect(() => {
    initializePostHog(posthog, auth?.user)
  }, [auth?.user, posthog])

  return (
    <>
      {children}
      <Toaster richColors />
    </>
  )
}
